<template>
    <div class="our-values">
        <nav>
            <ul>
                <li v-for="value in values" :class="{ 'is-active': value.isActive }">
                    <div @mouseover="selectValue(value)"><span>{{ value.name }}</span></div>
                </li>
            </ul>
        </nav>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    Vue.component('value', {
        template: `
            <div class="value" v-show="isActive"><slot></slot></div>
        `,

        props: {
            name: { required: true },
            selected: { default: false }
        },

        data() {
            return {
                isActive: false
            };
        },

        mounted() {
            this.isActive = this.selected;
        }
    });

    export default {

        data() {
            return {
                values: [] 
            }
        },

        created() {
            this.values = this.$children;
        },

        mounted() {
            console.log(this.$children);
        },

        methods: {
            selectValue(selectedValue) {
                this.values.forEach(value => {
                    value.isActive = (value.name == selectedValue.name);
                });
            }
        }
    }
</script>

<style lang="scss">
    @media screen and (max-width: 768px) {
        .our-values {
            padding-bottom: 30px;
            nav {
                display: none;
            }
            .value {
                display: block !important;
                color: #b7b7b7;
                h3 {
                    font-size: 24px;
                    color: #FA4616;
                    margin-top: 2.23809524rem !important;
                }
                strong {
                    color: white;
                }
                p {
                    margin-bottom: .5rem;
                }
            }
        }
    }

    @media screen and (min-width: 768px) {
        .our-values {
            text-align: center;
            max-width: 740px;
            width: 100%;
            margin: 60px auto 0;
            position: relative;
            font-size: 16px;
            height: 360px;
            // background-image: url('../../images/value.png'); /* added in assets/styles/layout/flexible-content.scss */
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: contain;
            nav {
                display: block;
            }
            ul {
                list-style: none;
                margin: 0;
                padding: 0;
                display: flex;
                justify-content: space-between;
                li {
                    color: #b7b7b7;
                    width: 120px;
                    height: 120px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    backface-visibility: hidden;
                    position: absolute;
                    &:first-child {
                        bottom: 110px;
                        left: -5px;
                    }
                    &:nth-child(2) {
                        bottom: 75%;
                        left: 26%;
                    }
                    &:nth-child(3) {
                        bottom: 75%;
                        right: 26%;
                    }
                    &:last-child {
                        bottom: 110px;
                        right: -5px;
                    }
                    div {
                        position: absolute;
                        z-index: 2;
                        top: 0;
                        bottom: 0;
                        right: 0;
                        left: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #223848;
                        border: 4px solid #b7b7b7;
                        border-radius: 50%;
                        transform: rotateX(0deg);
                        transition: transform 700ms;
                    }
                    span {
                        transition: transform 300ms;
                    }
                    &:hover,
                    &.is-active {
                        div {
                            background: #FA4616;
                            border-color: #FA4616;
                            transform: rotateX(180deg);
                             span {
                                color: white;
                                transform: rotateX(180deg);
                            }
                        }
                    }
                }
            }
            .content {
                color: #b7b7b7;
                position: absolute;
                width: 359px;
                left: 26%;
                top: 195px;
                border-radius: 101px;
                display: table;
                height: 187px;
            }
            .value {
                font-size: 13px;
                h3 {
                    font-size: 30px;
                    color: #FA4616;
                }
                strong {
                    color: white;
                }
                p {
                    margin-bottom: .5rem;
                }
            }
        }
    }
</style>